import { Platform, StyleSheet, type TextStyle } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCheckoutDetailStyleDefs = {
  checkoutAccordion: {
    marginTop: 2,
    borderTopWidth: 1,
    borderTopColor: ticketColors.rule,
    paddingTop: 0,
  },

  /** Título de sección micro-caps (proto `.sec-title`). */
  checkoutSecTitle: {
    fontSize: 11,
    fontWeight: '800',
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },

  /** Fila de título estático en desktop (proto no colapsa el detalle). */
  checkoutDetailTitleRow: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: spacing.sm,
    marginBottom: spacing.sm,
  },

  checkoutAccHead: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingVertical: 12,
  },

  checkoutAccHeadText: {
    fontSize: 11,
    fontWeight: '800',
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },

  checkoutAccBody: {
    paddingBottom: 12,
    gap: 6,
  },

  checkoutAccRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },

  checkoutAccRowDivider: {
    marginTop: 4,
    paddingTop: 6,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutAccRowLabel: {
    flex: 1,
    minWidth: 0,
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  checkoutAccRowValue: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontFamily: ticketFonts.mono,
  },

  checkoutDetailTableScroll: {
    marginHorizontal: -spacing.xs,
  },

  checkoutDetailLinesScroll: {
    maxHeight: 216,
    ...(Platform.OS === 'web'
      ? ({
          overflowY: 'auto',
        } as const)
      : null),
  },

  checkoutDetailTableInner: {
    minWidth: '100%',
    gap: 0,
  },

  checkoutDetailTableInnerWide: {
    minWidth: 280,
  },

  checkoutDetailToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },

  checkoutDetailToggleLabel: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    minWidth: 0,
  },

  /** Caja bordeada que envuelve la tabla (proto `.ticket-table`). */
  checkoutDetailTableBody: {
    flex: 1,
    minWidth: 280,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    overflow: 'hidden',
  },

  checkoutDetailTableBodyWide: {
    width: '100%',
    minWidth: 0,
  },

  checkoutDetailProductNameText: {
    flex: 1,
    minWidth: 0,
  },

  checkoutDetailColHint: {
    width: 22,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  checkoutDetailTableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingVertical: 7,
    paddingHorizontal: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.counter,
  },

  checkoutDetailTableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    minHeight: 32,
    paddingVertical: 8,
    paddingHorizontal: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },

  checkoutDetailTableRowLast: {
    borderBottomWidth: 0,
  },

  checkoutDetailHeaderCell: {
    fontSize: 10.5,
    color: ticketColors.ink3,
    fontWeight: '800',
    letterSpacing: 0.4,
    textTransform: 'uppercase' as const,
    fontFamily: ticketFonts.sans,
  },

  checkoutDetailCell: {
    fontSize: 13,
    color: ticketColors.ink2,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
  },

  checkoutDetailColProduct: {
    flex: 1,
    minWidth: 108,
  },

  checkoutDetailCellProduct: {
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },

  checkoutDetailProductCol: {
    flex: 1,
    minWidth: 108,
    gap: 2,
  },

  checkoutDetailColQty: {
    width: 44,
    textAlign: 'right',
    flexShrink: 0,
  },

  checkoutDetailCellMoney: {
    minWidth: 84,
    textAlign: 'right',
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    flexShrink: 0,
  },

  checkoutDetailCellMoneyWide: {
    minWidth: 92,
    flexShrink: 0,
  },

  checkoutDetailDiscount: {
    color: ticketColors.ok,
    fontWeight: '700',
    fontFamily: ticketFonts.mono,
  },

  checkoutDetailNet: {
    color: ticketColors.ink,
    fontWeight: '800',
    fontFamily: ticketFonts.mono,
  },

  checkoutDetailMoneyCellStack: {
    alignItems: 'flex-end',
    gap: 1,
  },

  /** Precio de lista tachado cuando la línea tiene descuento (tabla desktop). */
  checkoutDetailWas: {
    fontSize: 11,
    color: ticketColors.ink3,
    fontWeight: '600',
    textDecorationLine: 'line-through',
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontFamily: ticketFonts.mono,
  },
} as const;
